export default [
    {
        path: 'parametrizacao',
        component: () => import(
            '@/views/atencao-basica/parametrizacao/Index'
        ),
        redirect: 'parametrizacao/form',
        children: [
            {
                name: 'atencao-basica-parametrizacao-form',
                path: 'form',
                component: () => import(
                    '@/views/atencao-basica/parametrizacao/Form'
                )
            },
        ],
    },
]